<!-- Main menu -->
<span>
    <img src="assets/images/logo/Global Pay wsfx_Logo.png" alt="globalPay wsfx logo" (click)="gotoHome()"  style="height:40px;margin-left: 15px; margin-top: 10px;cursor: pointer;">
</span>
<span class="navbar-container main-menu-content">
    <ul class="nav navbar-nav" id="main-menu-navigation" layout="horizontal" core-menu>

    </ul>
</span>
<!--/ Main menu -->